module.exports = __webpack_public_path__ + "static/img/companyProfile.b03b028b.png";